
import {css} from 'styled-components';

const style = css`
  
`;

export default style;